import { useState } from 'react';
import { Box, IconButton, Link, Typography, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { useRemoveProductMutation } from '@/apis/extended/productApi';
import { ProductCardImage } from '@/components/ProductCard/ProductCardImage';
import { ProductBadges } from '@/components/ProductDetail/ProductBadges';
import { formatNumber } from '@/utils/helper';
import { Product } from '@/types/ProductType';

type AgentProductCardProps = {
  product?: Product;
  isContract?: boolean;
  href?: string;
  navigateTo?: string;
};

export const AgentProductCard = ({
  product,
  isContract = false,
  href,
  navigateTo,
}: AgentProductCardProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { productId } = useParams();

  return (
    <Box
      sx={{
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={() => navigate(navigateTo!)}
    >
      <ProductCardImage product={product} />
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          position: 'absolute',
          top: '16px',
          right: '16px',
          zIndex: 1,
        }}
      >
        <ProductBadges product={product} />
      </Box>
      <Box
        sx={{
          mt: 1,
          px: 1,
          minHeight: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h4">
          $ {formatNumber(product?.price ?? 0)}
        </Typography>
        <Box sx={{ display: 'flex', gap: '4px' }}>
          <Link
            href={product?.url}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton
              sx={{
                color: theme.palette.greyShades.grey1,
              }}
              size="small"
            >
              <i className="fa-light fa-link" />
            </IconButton>
          </Link>
        </Box>
      </Box>
      <Box sx={{ mt: '4px' }}>
        <Typography variant="h5" sx={{ color: theme.palette.greyShades.grey1 }}>
          {product?.name}
        </Typography>
      </Box>
    </Box>
  );
};
